import { createSlice } from '@reduxjs/toolkit'
import { failed } from '../../../reducer-helper'
import {
  getLastInvoice,
  payLastInvoice,
} from '../../../../components/workspace/settings/billing/pay-for-subscription/slice'

const initialState = {
  data: {
    invoice: null,
    paymentMethodId: null,
  },
  showPopup: false,
  error: null,
  status: null,
}

const slice = createSlice({
  name: 'payForSubscriptionForm',
  initialState,
  reducers: {
    setShowPopupState(state, action) {
      state.showPopup = action.payload.showPopup
    },
    changePaymentMethod: (state, action) => {
      state.data.paymentMethodId = action.payload.paymentMethodId
    },
    changeRequestStatus: (state, action) => {
      state.status = action.payload.status
    },
    resetForm: () => initialState,
  },
  extraReducers(builder) {
    builder.addCase(getLastInvoice.fulfilled, (state, action) => {
      state.data.invoice = action.payload.invoice
    })
    builder.addCase(payLastInvoice.fulfilled, () => initialState)
    builder.addCase(payLastInvoice.rejected, failed)
  },
})

const selectSlice = (state) => state.payForSubscriptionForm
export const selectData = (state) => selectSlice(state).data
export const selectShowPopup = (state) => selectSlice(state).showPopup
export const selectError = (state) => selectSlice(state).error
export const selectRequestStatus = (state) => selectSlice(state).status

const { reducer, actions } = slice

export const { changePaymentMethod, resetForm, changeRequestStatus, setShowPopupState } = actions

export default reducer
